import MUIBreadcrumbs from '@material-ui/core/Breadcrumbs';
import MUILink from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  () => ({
    ol: {
      color: `${color.$11}`,
    },
    li: {
      '& a': {
        '&:hover': {
          color: `${color.$10}`,
          textDecoration: 'none',
        },
      },
      '&:nth-last-child(1) a': {
        cursor: 'initial',
        color: `${color.$10}`,
      },
    },
    separator: {
      margin: '0 4px',
    },
  }),
  { name: 'Breadcrumbs' },
);

const Separator = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 18 18"
  >
    <path
      d="M7.5 4.5L6.44 5.56 9.88 9l-3.44 3.44L7.5 13.5 12 9z"
      style={{ fill: `${color.$11}` }}
    />
  </svg>
);

const Breadcrumbs = ({ className, list = [] }) => {
  const classes = useStyles();
  const history = useHistory();
  const [linkComponents, setLinkComponents] = useState([]);

  const onClickLink = path => {
    history.push(path);
  };

  useEffect(() => {
    const createLinkComponents = () => {
      return list.map((l, index) => {
        return (
          <MUILink
            key={`link-layer-${index}`}
            color="inherit"
            href={l?.url}
            onClick={e => {
              e.preventDefault();
              onClickLink(l?.url);
            }}
          >
            {l?.text}
          </MUILink>
        );
      });
    };

    setLinkComponents(createLinkComponents());
  }, [list]);

  return (
    <MUIBreadcrumbs
      className={className}
      classes={classes}
      separator={<Separator />}
      aria-label="breadcrumb"
    >
      {linkComponents}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
